<template>
  <b-container fluid class="w-100 pt-5 px-5 mt-5">

    <b-tabs content-class="mt-3 p-0 w-100" align="center"
            active-nav-item-class="font-weight-bold bg-warning">

      <b-tab class="w-100">
        <template #title>
          <b-row class="d-flex flex-row justify-content-center m-0 p-0 tab-title-container">
            <b-col class="d-flex flex-column align-items-center justify-content-center p-0 m-0">
              <b-button size="lg" class="tab-btn first-tab-btn border-0">{{ tab1 }}</b-button>
            </b-col>
          </b-row>
        </template>

        <b-row class="tab-row">
          <slot name="tab-1"></slot>
        </b-row>
      </b-tab>

      <b-tab class="w-100">
        <template #title>
          <b-row class="d-flex flex-row justify-content-center m-0 p-0 tab-title-container">
            <b-col class="d-flex flex-column align-items-center justify-content-center p-0 m-0">
              <b-button size="lg" class="tab-btn second-tab-btn border-0">{{ tab2 }}</b-button>
            </b-col>
          </b-row>
        </template>

        <b-row class="tab-row">
          <slot name="tab-2"></slot>
        </b-row>
      </b-tab>

    </b-tabs>

  </b-container>
</template>

<script>
export default {
  name: "S201",
  props: ['tab1', 'tab2']
}
</script>

<style scoped>
.tab-btn {
  transform: rotate(25deg);
}

.tab-btn:hover {
  transform: scale(1.2);
  background-color: var(--secondary) !important;
}

.first-tab-btn {
  background-color: var(--light-primary) !important;
}

.second-tab-btn {
  background-color: var(--primary) !important;
}

.tab-icon {
  font-size: 24px;
  background-color: var(--primary);
  color: white;
  padding: 8px 10px 0;
}

.card-descript {
  font-size: 13px;
}

.tab-row .card {
  height: 250px !important;
}
</style>